import React, { useEffect, useState } from "react";

import HTMLDisplay from "./HTMLDisplay";
import { Box, Typography } from "@mui/material";

const Variability_Template = ({ variability, variabilityData }) => {
  const [htmlArray, setHtmlArray] = useState([]);

  useEffect(() => {
    setHtmlArray([]);
    if (Array.isArray(variabilityData) && variability.template) {
      replacePlaceholders();
    }
  }, [variabilityData]);

  const replacePlaceholders = () => {
    for (const record of variabilityData) {
      const placeholders = Object.keys(record.data);

      let newHtml = variability.template;
      for (const placeholder of placeholders) {
        newHtml = newHtml.replaceAll(
          `#${placeholder}#`,
          record.data[placeholder]
        );
      }
      setHtmlArray((current) => {
        let array = [...current];

        array.push(newHtml);

        return array;
      });
    }
  };

  if (htmlArray.length === 0)
    return <Typography>Nothing to display</Typography>;

  return (
    <Box sx={{ padding: "8px" }}>
      {htmlArray.map((html) => (
        <HTMLDisplay
          html={html}
          noStyle
        />
      ))}
    </Box>
  );
};

export default Variability_Template;
